import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { TRANSACTIONS_QUERY_KEY } from "./useTransactions";
import { ANALYTICS_QUERY_KEY } from "./useSummary";

type CreateTransactionBody = components["schemas"]["CreateTransactionBody"];
type TransactionResponse = components["schemas"]["TransactionResponse"];

export function useCreateTransaction() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<TransactionResponse, Error, CreateTransactionBody>({
    mutationFn: async (body) => {
      const { data, error } = await client.POST("/api/transactions", { body });
      if (error !== undefined) {
        throw new Error("Failed to create transaction");
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TRANSACTIONS_QUERY_KEY });
      void queryClient.invalidateQueries({ queryKey: ANALYTICS_QUERY_KEY });
    },
  });
}
